import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import EditStaticPageManage from '../../../components/siteadmin/EditStaticPage/EditStaticPage';
import Loader from '../../../components/Loader/Loader';

import editStaticPage from './editStaticPage.graphql';
import { withQuery } from '../../../hoc/withGraphql';

import s from './EditStaticPage.css';

const EditStaticPage = (props) => {

    const { editStaticPageData, title } = props;

    if (editStaticPageData?.loading) return <div><Loader type={"text"} /></div>

    if (editStaticPageData && editStaticPageData.getEditStaticPage === null) {
        return <div className={cx(s.pagecontentWrapper)}><NotFound /></div>
    }
    const staticPage = editStaticPageData?.getEditStaticPage;

    const initialValues = staticPage ? {
        ...staticPage,
        dynamicStaticPage: staticPage.dynamicStaticPage?.length > 0
            ? staticPage.dynamicStaticPage.map(d => ({
                language: d.language || 'en',
                metaTitle: d.metaTitle || '',
                metaDescription: d.metaDescription || '',
                content: d.content || ''
            }))
            : [{ language: 'en', metaTitle: staticPage.metaTitle || '', metaDescription: staticPage.metaDescription || '', content: staticPage.content || '' }]
    } : {};

    return (
        <EditStaticPageManage
            title={title} initialValues={initialValues}
        />
    );
}

EditStaticPage.propTypes = {
    title: PropTypes.string.isRequired,
    blogId: PropTypes.number.isRequired,
    editStaticPageData: PropTypes.shape({
        loading: PropTypes.bool,
        getEditStaticPage: PropTypes.object
    }),
};

export default compose(
    withStyles(s),
    withQuery(editStaticPage, {
        name: 'editStaticPageData',
        options: (props) => ({
            variables: {
                id: props.pageId,
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    }),
)(EditStaticPage);